import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useMutation, useQuery, useQueryClient } = ReactQueryV5;
import { del, get, post } from "../services/httpClient";
import type { CalendarTemplate } from "./types";

type CreateSlotsPayload = {
  templateId: string;
  targetWeek: `${number}/${number}`;
};

type SaveTemplatePayload = {
  name: string;
  sourceWeek: `${number}/${number}`;
  templateTypes: number[];
};

type GetTemplatesResponse = {
  templates: CalendarTemplate[];
};

const CALENDAR_TEMPLATES_KEY = ["calendarTemplates"];

export const useGetTemplates = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: CALENDAR_TEMPLATES_KEY,
    queryFn: () =>
      get<{ data: GetTemplatesResponse }>("slot-templates/templates").then(
        (r) => r.data,
      ),
    ...options,
  });

export const useCreateSlots = () =>
  useMutation({
    mutationFn: (payload: CreateSlotsPayload) =>
      post<unknown, CreateSlotsPayload>(
        "slot-templates/apply_template",
        payload,
      ),
  });

export const useSaveTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: SaveTemplatePayload) =>
      post<unknown, SaveTemplatePayload>("slot-templates/templates", payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: CALENDAR_TEMPLATES_KEY }),
  });
};

export const useDeleteTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (templateId: string) =>
      del<unknown, undefined>(
        `slot-templates/templates/${templateId}`,
        undefined,
      ),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: CALENDAR_TEMPLATES_KEY }),
  });
};
